export function getProgressWidth(progress) {
  return (progress < 100 ? progress : 100) + '%'
}
